import { render } from "./ThreadDetails.vue?vue&type=template&id=03f10d32"
import script from "./ThreadDetails.vue?vue&type=script&lang=js"
export * from "./ThreadDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__